// Les visuels s'affichent sous la réponse et la carte dans le panneau : « la carte ci-dessus » envoie
// le lecteur au mauvais endroit (Qwen l'écrit encore malgré la consigne de render_visual).
const RENVOI = /\b((?:l|L)a carte|(?:l|L)e tableau|(?:l|L)e graphique|(?:l|L)e visuel|(?:l|L)e document|(?:l|L)e rapport|(?:l|L)['’]aperçu)\s+ci-dessus\b/g;
const CARTE = /\b((?:l|L)a carte)\s+ci-dessous\b/g;
export const sansRenvoiErrone = (texte) => (typeof texte === 'string' ? texte.replace(RENVOI, '$1').replace(CARTE, '$1') : texte);
